import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.FavoriteVacancyButton),
  () => import('./FavoriteVacanciesButton'),
  (button) => {
    ComponentUtil.binder(Hooks.FavoriteVacancyButton, button);
  },
);
